import { isAxiosError } from 'axios';

/** Server message when the API rejected the request, else the generic error text. */
export function errorMessage(error: unknown, fallback: string): string {
  if (isAxiosError(error)) {
    const message = (error.response?.data as { message?: unknown } | undefined)?.message;
    if (typeof message === 'string') return message;
    if (Array.isArray(message) && typeof message[0] === 'string') return message[0];
  }
  return error instanceof Error && error.message ? error.message : fallback;
}
